import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MapParentheses } from "../components/site/MapParentheses";
import { CONTACT } from "../data/content";

export default function CartePage() {
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <div data-testid="carte-page" className="min-h-screen bg-[#FBF7EF]" style={{ fontFamily: "Manrope, sans-serif" }}>
      <header className="max-w-[1400px] mx-auto px-5 md:px-8 pt-6 flex items-center justify-between">
        <Link to="/" data-testid="carte-back-home">
          <img src="/logo-tpoz.png" alt="T'POZ" className="h-16 sm:h-20 w-auto" />
        </Link>
        <Link
          to="/"
          data-testid="carte-back-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#A66E08] hover:text-[#C6870F] transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
      </header>

      <MapParentheses />

      <footer className="bg-[#2E2A22] text-[#FBF7EF]/60 text-center text-xs py-8">
        T'POZ — un réseau de {CONTACT.association} · {CONTACT.phone}
      </footer>
    </div>
  );
}
